module.exports = __webpack_public_path__ + "static/media/search.e5e8b9c6.svg";